import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface BiomassBurningCellDisplayProps {
  value: any
}

export const BiomassBurningCellDisplay = ({ value }: BiomassBurningCellDisplayProps) => {
  const { t } = useTranslation('@cibo/landmanager/BiomassBurningEditor')
  const data = value?.result ?? value?.input

  return data.hadBiomassBurning === true || data.hadBiomassBurning === false ? (
    <Stack>
      <Typography>{data?.hadBiomassBurning === false ? t('no') : t('yes')}</Typography>
    </Stack>
  ) : null
}
